"use strict";

exports.__esModule = true;
exports.AiPromptDialog = AiPromptDialog;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _AuthContext = require("../../Auth/AuthContext");
var _EnvContext = require("../../Env/EnvContext");
var _RestAPIContext = require("../../API/RestAPI/RestAPIContext");
var _Translator = require("../../Core/Translator");
var _Heading = require("../../Core/Heading");
var _svcAiClient = require("./svcAiClient");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var Hint = _styledComponents["default"].p.withConfig({
  displayName: "AiPromptDialog__Hint",
  componentId: "sc-1sbe6x4-0"
})(["margin:0 0 10px;font-size:12.5px;color:", ";"], function (props) {
  return props.theme.mutedColor;
});
var Busy = _styledComponents["default"].div.withConfig({
  displayName: "AiPromptDialog__Busy",
  componentId: "sc-1sbe6x4-1"
})(["display:flex;align-items:center;gap:12px;margin-top:14px;font-size:12.5px;color:", ";"], function (props) {
  return props.theme.mutedColor;
});
var RequestId = _styledComponents["default"].div.withConfig({
  displayName: "AiPromptDialog__RequestId",
  componentId: "sc-1sbe6x4-2"
})(["margin-top:6px;font-size:11px;opacity:0.7;"]);
var Footer = _styledComponents["default"].div.withConfig({
  displayName: "AiPromptDialog__Footer",
  componentId: "sc-1sbe6x4-3"
})(["display:flex;justify-content:flex-end;gap:6px;margin-top:16px;"]);
var CALLS = {
  dashboard: {
    create: _svcAiClient.generateDashboard,
    edit: _svcAiClient.editDashboard
  },
  report: {
    create: _svcAiClient.generateReport,
    edit: _svcAiClient.editReport
  }
};
var TEXT = {
  dashboard: {
    create: {
      title: ["AiAuthoring.dashboard.create.title", "Create a dashboard with AI"],
      placeholder: ["AiAuthoring.dashboard.create.placeholder", "e.g. OEE and availability for every device over the last week, one chart per metric, with a clock top right"],
      action: ["AiAuthoring.dashboard.create.action", "Generate dashboard"]
    },
    edit: {
      title: ["AiAuthoring.dashboard.edit.title", "Edit this dashboard with AI"],
      placeholder: ["AiAuthoring.dashboard.edit.placeholder", "e.g. add a clock top right and make the OEE chart a bar chart"],
      action: ["AiAuthoring.dashboard.edit.action", "Apply changes"]
    }
  },
  report: {
    create: {
      title: ["AiAuthoring.report.create.title", "Create a report with AI"],
      placeholder: ["AiAuthoring.report.create.placeholder", "e.g. OEE, availability and part count by device for the reporting period"],
      action: ["AiAuthoring.report.create.action", "Generate report"]
    },
    edit: {
      title: ["AiAuthoring.report.edit.title", "Edit this report with AI"],
      placeholder: ["AiAuthoring.report.edit.placeholder", "e.g. add a total column and drop the availability column"],
      action: ["AiAuthoring.report.edit.action", "Apply changes"]
    }
  }
};

/**
 * Takes a plain-English prompt and asks svc-ai for a new document (`mode`
 * "create") or an edited element tree for `document` ("edit"). Calls
 * `onResult` with the service's answer and closes. Leaving the dialog while
 * a run is in flight aborts it, which cancels the model run on the server.
 */
function AiPromptDialog(_ref) {
  var kind = _ref.kind,
    mode = _ref.mode,
    document = _ref.document,
    isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    onResult = _ref.onResult;
  var theme = (0, _react.useContext)(_styledComponents.ThemeContext) || {};
  var _ref2 = (0, _react.useContext)(_Translator.TranslatorContext) || {},
    _ref2$translate = _ref2.translate,
    translate = _ref2$translate === void 0 ? function (id, fallback) {
      return fallback;
    } : _ref2$translate;
  var auth = (0, _react.useContext)(_AuthContext.AuthContext) || {};
  var api = (0, _react.useContext)(_RestAPIContext.RestAPIContext) || {};
  var env = (0, _react.useContext)(_EnvContext.EnvContext) || {};
  var _useState = (0, _react.useState)(""),
    prompt = _useState[0],
    setPrompt = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    busy = _useState2[0],
    setBusy = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    error = _useState3[0],
    setError = _useState3[1];
  var controller = (0, _react.useRef)(null);
  var text = TEXT[kind][mode];
  var t = function t(_ref3) {
    var id = _ref3[0],
      fallback = _ref3[1];
    return translate(id, fallback);
  };
  (0, _react.useEffect)(function () {
    if (!isOpen) {
      setError(null);
    }
  }, [isOpen]);
  var cancel = function cancel() {
    if (controller.current) {
      controller.current.abort();
      controller.current = null;
    }
    setBusy(false);
    onClose();
  };
  var run = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var trimmed, abort, options, call, result, _t, _t2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            trimmed = prompt.trim();
            if (!(!trimmed || busy)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            abort = new AbortController();
            controller.current = abort;
            setBusy(true);
            setError(null);
            options = {
              token: auth.token,
              plant: api.plantName,
              baseUrl: (0, _svcAiClient.getSvcAiBase)(env),
              signal: abort.signal
            };
            _context.p = 2;
            call = CALLS[kind][mode];
            if (!(mode === "create")) {
              _context.n = 4;
              break;
            }
            _context.n = 3;
            return call(trimmed, options);
          case 3:
            _t = _context.v;
            _context.n = 6;
            break;
          case 4:
            _context.n = 5;
            return call(trimmed, document.element, options);
          case 5:
            _t = _context.v;
          case 6:
            result = _t;
            _context.n = 7;
            return onResult(result, trimmed);
          case 7:
            setPrompt("");
            onClose();
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t2 = _context.v;
            if (_t2.name !== "AbortError") {
              setError(_t2);
            }
          case 9:
            _context.p = 9;
            controller.current = null;
            setBusy(false);
            return _context.f(9);
          case 10:
            return _context.a(2);
        }
      }, _callee, null, [[2, 8, 9, 10]]);
    }));
    return function run() {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    className: theme.bodyClassName,
    isOpen: isOpen,
    onClose: cancel,
    canOutsideClickClose: !busy,
    style: {
      width: "560px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_HEADER
  }, /*#__PURE__*/_react["default"].createElement(_core.Icon, {
    icon: _icons.IconNames.CLEAN,
    size: 24
  }), /*#__PURE__*/_react["default"].createElement(_Heading.Heading, {
    level: 5
  }, t(text.title))), /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.DIALOG_BODY,
    "data-testid": "AiPromptDialog"
  }, /*#__PURE__*/_react["default"].createElement(Hint, null, mode === "create" ? translate("AiAuthoring.hint.create", "Describe what the {kind} should show. It is built from this plant's real metrics and devices.", {
    kind: kind
  }) : translate("AiAuthoring.hint.edit", "Describe the change to make to this {kind}.", {
    kind: kind
  })), /*#__PURE__*/_react["default"].createElement(_core.TextArea, {
    fill: true,
    autoFocus: true,
    rows: 4,
    value: prompt,
    disabled: busy,
    placeholder: t(text.placeholder),
    onChange: function onChange(event) {
      return setPrompt(event.target.value);
    },
    onKeyDown: function onKeyDown(event) {
      if ((event.metaKey || event.ctrlKey) && event.key === "Enter") {
        run();
      }
    },
    "data-testid": "AiPromptDialog.prompt"
  }), busy && /*#__PURE__*/_react["default"].createElement(Busy, null, /*#__PURE__*/_react["default"].createElement(_core.Spinner, {
    size: 18
  }), translate("AiAuthoring.busy", "Working with the plant's data. This takes up to a minute or two.")), error && !busy && /*#__PURE__*/_react["default"].createElement(_core.Callout, {
    intent: _core.Intent.DANGER,
    style: {
      marginTop: 14
    },
    "data-testid": "AiPromptDialog.error"
  }, (0, _svcAiClient.describeSvcAiError)(error, translate), error.requestId && /*#__PURE__*/_react["default"].createElement(RequestId, null, translate("AiAuthoring.requestId", "Request id"), ":", " ", error.requestId)), /*#__PURE__*/_react["default"].createElement(Footer, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    text: translate("AiAuthoring.Button.Cancel", "Cancel"),
    onClick: cancel
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    intent: _core.Intent.PRIMARY,
    icon: _icons.IconNames.CLEAN,
    text: t(text.action),
    loading: busy,
    disabled: !prompt.trim(),
    onClick: run,
    "data-testid": "AiPromptDialog.run"
  }))));
}